import {CheckCheck, RotateCcw, SlidersHorizontal, UserRoundCheck, X} from 'lucide-react'

type Props = {
  user: any
  scopeLabel: string
  itemLabel: string
  totalCount: number
  activeCount: number
  loading: boolean
  onChange: (selectAll: boolean) => void
  onClose: () => void
}

function initials(name = '') {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase()
}

const UserBulkPermissionsModal = ({
  user,
  scopeLabel,
  itemLabel,
  totalCount,
  activeCount,
  loading,
  onChange,
  onClose,
}: Props) => {
  const coverage = totalCount ? Math.round((activeCount / totalCount) * 100) : 0

  return (
    <div className='ua-user-bulk-modal'>
      <div className='ua-bulk-modal__header'>
        <span className='ua-section__heading-icon'>
          <UserRoundCheck size={19} />
        </span>
        <div>
          <small>Ação por usuário</small>
          <h3>Gerenciar todos os acessos</h3>
        </div>
        <button
          type='button'
          className='ua-icon-button'
          aria-label='Fechar'
          disabled={loading}
          onClick={onClose}
        >
          <X size={15} />
        </button>
      </div>

      <div className='ua-user-bulk-modal__profile'>
        <span className='ua-avatar'>
          {user.src ? <img src={user.src} alt='' /> : initials(user.name)}
        </span>
        <span className='ua-user-cell__copy'>
          <strong>{user.name}</strong>
          <small>{user.email || scopeLabel}</small>
        </span>
        <span className='ua-badge'>
          {activeCount} de {totalCount} ativos
        </span>
      </div>

      <div className='ua-user-bulk-modal__coverage'>
        <div>
          <span>Progresso de acesso em {scopeLabel}</span>
          <strong>{coverage}%</strong>
        </div>
        <span className='ua-user-bulk-modal__track'>
          <span style={{width: `${coverage}%`}} />
        </span>
      </div>

      <div className='ua-bulk-modal__body'>
        <p>
          A ação será aplicada a {totalCount} {itemLabel} de <strong>{scopeLabel}</strong>,
          inclusive aos itens que não estão visíveis por causa da busca.
        </p>
        <button
          type='button'
          className='ua-bulk-action is-positive'
          disabled={loading || !totalCount || activeCount === totalCount}
          onClick={() => onChange(true)}
        >
          <span>{loading ? <span className='ua-spinner' /> : <CheckCheck size={18} />}</span>
          <span>
            <strong>Selecionar todos</strong>
            <small>Concede todos os acessos disponíveis para este usuário.</small>
          </span>
        </button>
        <button
          type='button'
          className='ua-bulk-action is-negative'
          disabled={loading || !activeCount}
          onClick={() => onChange(false)}
        >
          <span>{loading ? <span className='ua-spinner' /> : <RotateCcw size={18} />}</span>
          <span>
            <strong>Remover todos</strong>
            <small>Revoga todos os acessos deste usuário dentro desta seção.</small>
          </span>
        </button>
      </div>

      <div className='ua-user-bulk-modal__note'>
        <SlidersHorizontal size={14} />
        Depois da ação, você ainda poderá ajustar cada item individualmente na matriz.
      </div>
    </div>
  )
}

export default UserBulkPermissionsModal
